/**
 * PDF hub: iframe preview inside <dialog>. No PDF.js, no auto window.open.
 */
(function () {
  var INQUIRY_SENT_URL = '/?sections=inquiry-sent';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('overflow-hidden', on);
  }

  function cleanUrl(raw) {
    var u = String(raw || '').trim().replace(/^["']+|["']+$/g, '');
    if (!u) return '';
    if (!/^https?:\/\//i.test(u)) u = u.indexOf('//') === 0 ? 'https:' + u : 'https://' + u;
    return u;
  }

  function shopDomainPdfUrl(url) {
    var u = cleanUrl(url);
    if (!u || u.indexOf('/products/') !== -1) return '';
    if (u.indexOf('/cdn/shop/files/') !== -1 && u.indexOf(window.location.host) !== -1) return u;
    var filePart = '';
    if (u.indexOf('/cdn/shop/files/') !== -1) filePart = u.split('/cdn/shop/files/').pop();
    else if (u.indexOf('/files/') !== -1) filePart = u.split('/files/').pop();
    if (!filePart || filePart.indexOf('.pdf') === -1) return '';
    return window.location.origin + '/cdn/shop/files/' + filePart;
  }

  function iframeViewerUrl(url) {
    var base = shopDomainPdfUrl(url) || cleanUrl(url);
    if (!base) return '';
    return base.split('#')[0] + '#toolbar=0&navpanes=0&scrollbar=1&view=FitH';
  }

  function resolvePdfUrl(root) {
    var url = shopDomainPdfUrl(root.getAttribute('data-pdf-url'));
    if (url) return url;
    var link = root.querySelector('[data-pdf-open-tab][href], a[href*=".pdf"]');
    if (link) url = shopDomainPdfUrl(link.getAttribute('href'));
    return url;
  }

  function applyCanonicalPdfUrls(root, url) {
    var canon = shopDomainPdfUrl(url) || url;
    if (!canon) return '';
    root.setAttribute('data-pdf-url', canon);
    root.querySelectorAll('a[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (href.indexOf('.pdf') !== -1 || href.indexOf('/files/') !== -1) {
        var next = shopDomainPdfUrl(href) || canon;
        if (next) anchor.setAttribute('href', next.split('#')[0]);
      }
    });
    return canon;
  }

  function initRfq(root) {
    var form = qs('#PdfRfqContactForm', root);
    var iframe = qs('[data-pdf-rfq-iframe]', root);
    if (!form || !iframe) return;

    var loadingEl = qs('[data-pdf-rfq-loading]', root);
    var successEl = qs('[data-pdf-rfq-success]', root);
    var errorEl = qs('[data-pdf-rfq-error]', root);
    var msgField = qs('[data-pdf-rfq-message]', root);
    var submitting = false;

    function rfqState(state, text) {
      if (loadingEl) loadingEl.hidden = state !== 'loading';
      if (successEl) successEl.hidden = state !== 'success';
      if (errorEl) {
        errorEl.hidden = state !== 'error';
        if (text) errorEl.textContent = text;
      }
    }

    function warmIframe() {
      if (!iframe.getAttribute('src')) iframe.setAttribute('src', INQUIRY_SENT_URL);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      submitting = true;
      rfqState('loading');

      var body = form.elements['contact[body]'] || qs('[data-pdf-rfq-body]', root);
      if (body) {
        body.value = [
          'RFQ from PDF viewer',
          'Product: ' + (root.getAttribute('data-product-title') || ''),
          'URL: ' + (root.getAttribute('data-product-url') || ''),
          'SKU: ' + (root.getAttribute('data-product-sku') || ''),
          'Name: ' + (form.elements['contact[name]'] && form.elements['contact[name]'].value),
          'Email: ' + (form.elements['contact[email]'] && form.elements['contact[email]'].value),
          'Phone: ' + (form.elements['contact[phone]'] && form.elements['contact[phone]'].value),
          '',
          msgField ? msgField.value : ''
        ].join('\n');
      }

      warmIframe();
      form.setAttribute('target', iframe.getAttribute('name'));
      form.submit();
      window.setTimeout(function () {
        rfqState('success');
        form.reset();
        submitting = false;
        form.removeAttribute('target');
      }, 2500);
    });

    warmIframe();
  }

  function initHub(root) {
    var url = resolvePdfUrl(root);
    if (!url) return;
    url = applyCanonicalPdfUrls(root, url);

    var dialog = qs('[data-pdf-dialog]', root);
    var openBtn = qs('[data-pdf-open]', root);
    var closeBtn = qs('[data-pdf-close]', root);
    var viewerIframe =
      qs('[data-pdf-iframe]', root) || qs('[data-pdf-viewer-iframe]', root) || qs('[data-pdf-viewer]', root);
    var loadingEl = qs('[data-pdf-loading]', root);
    var fallbackEl = qs('[data-pdf-fallback]', root) || qs('[data-pdf-viewer-fallback]', root);
    var canvasWrap = qs('[data-pdf-canvas]', root);

    if (!dialog || !openBtn || !viewerIframe) return;

    if (canvasWrap) canvasWrap.hidden = true;

    var viewerSrc = iframeViewerUrl(url);
    var loaded = false;

    function showIframe() {
      if (loadingEl) loadingEl.hidden = true;
      if (fallbackEl) fallbackEl.hidden = true;
      viewerIframe.hidden = false;
      viewerIframe.removeAttribute('hidden');
    }

    function showLoading() {
      if (loadingEl) loadingEl.hidden = false;
      if (fallbackEl) fallbackEl.hidden = true;
    }

    function loadIntoIframe() {
      if (!viewerSrc) return;
      showLoading();
      viewerIframe.addEventListener(
        'load',
        function onLoad() {
          viewerIframe.removeEventListener('load', onLoad);
          loaded = true;
          showIframe();
        }
      );
      viewerIframe.src = viewerSrc;
      window.setTimeout(function () {
        if (!loaded) showIframe();
      }, 8000);
    }

    function openDialog(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (typeof dialog.showModal !== 'function') return false;
      if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
      if (!dialog.open) dialog.showModal();
      lockScroll(true);
      loadIntoIframe();
      return false;
    }

    function closeDialog() {
      if (!dialog.open) return;
      dialog.close();
      lockScroll(false);
    }

    openBtn.addEventListener('click', openDialog);
    if (closeBtn) closeBtn.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (ev) {
      if (ev.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', function (ev) {
      ev.preventDefault();
      closeDialog();
    });

    initRfq(root);
  }

  function boot() {
    document.querySelectorAll('[data-pdf-hub], [data-pdf-preview]').forEach(initHub);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
